<template>
	<a-row class="reportSearchBox">
		<a-col :span='24' class="titleBox">
			<a-col :span='4' class="left">查询条件</a-col>
			<a-col :span='20' class="right">
				<a-button type="primary" class="btn" @click="onSearch()">查询</a-button>
				<a-button type="default" class="btn" @click="onReset()">重置</a-button>
			</a-col>
		</a-col>
		<a-col :span='24'>
            <!--  layout="vertical" -->
            <!--  :wrapper-col="{ span: 18 }" -->
			<a-form-model :model="searchForm">
				<template v-for="(item, index) in searchList">
					<a-col :span='8' :key="index" v-if="item.Type != 'Hidden'">
						<a-form-model-item :label="`${item.Label}：`" :label-col="{ span: 8 }" :wrapper-col="{ span: 14 }">
							<!-- input -->
							<a-input v-if="item.Type == 'Txt'" v-model="searchForm[item.arr]" :placeholder="`请输入${item.Label}`"></a-input>
							<!-- date -->
							<a-date-picker v-if="item.Type == 'Date'" v-model="searchForm[item.arr]" :placeholder="`请选择${item.Label}`" format="YYYY/MM/DD" style="width: 100%;" />
							<!-- DateTime -->
							<a-date-picker v-if="item.Type == 'DateTime'" v-model="searchForm[item.arr]" :placeholder="`请选择${item.Label}`" showTime format="YYYY-MM-DD HH:mm:ss" style="width: 100%;" />
							<!-- select -->
							<a-select v-if="item.Type == 'Select2'" v-model="searchForm[item.arr]" :placeholder="`请选择${item.Label}`" style="width: 100%;">
								<template v-for="option in item.DataSource">
									<a-select-option :key="option.val" :label="option.txt" :value="option.val">{{ option.txt }}</a-select-option>
								</template>
							</a-select>
							<!-- Select字典查询 -->
							<a-select v-if="item.Type == 'Select' && !item.isLoading" v-model="searchForm[item.arr]" @change="selectQuery(item, index, searchForm[item.arr])" :placeholder="`请选择${item.Label}`" style="width: 100%;">
								<template v-for="option in item.DataSource">
									<a-select-option :key="option.val" :label="option.txt" :value="option.val">{{ option.txt }}</a-select-option>
								</template>
							</a-select>
						</a-form-model-item>
					</a-col>
				</template>
			</a-form-model>
		</a-col>
	</a-row>
</template>

<script>
	import postHeight from '@/controllers/postHeight';
	export default {
		extends: postHeight,
		computed: {
            localizedItemTxt() {
				return this.$store.state.reportInfo.localizedItemTxt;
            },
            tenant() {
                return this.$store.state.reportInfo.teannt;
            },
			rptKey() {
				return this.$store.state.reportInfo.rptKey;
            },
            isRptYesSpotCheck2() {
				return Object.is(this.localizedItemTxt, 'YES飞检报告2') && this.tenant.includes('pfizer');
            }
		},
		data() {
			return {
				form: this.$form.createForm(this, {
					name: 'reportSearchForm', // 表单域内字段 id 的前缀
				}),
				searchList: [],
				searchForm: {}
			}
		},
		mounted() {
            this.QueryConditions()
			this.$root.$bus.$on("onChangePortalMenu", options => this.QueryConditions(options));
		},
		destroyed() {
			this.$root.$bus.$off("onChangePortalMenu");
		},
		methods: {
            // 获取报表搜索项
			QueryConditions(options = {}) {
                const {
                    path
                } = options;
                if(path && path != '/report') {
                    return false;
                }
				this.$root.$bus.$emit("resetTable");
				let params = {
					reportKey: this.rptKey
				}
				this.$axios.QueryConditions(params).then(response => {
					if(response && response.success) {
						this.searchList = response.content;
						var searchForm = new Object()
						this.searchList.forEach(item => {
                            let IsCondition = Object.prototype.hasOwnProperty.call(item, "IsCondition") ? !!item.IsCondition : true;
							let formKey = `${item.ParamName}|${item.CtrlName}|${item.Eq}|${item.Type}|${IsCondition ? 'yes' : 'no'}`
							if(this.isRptYesSpotCheck2 && formKey.includes('t1.DtStart')) {
								let currentDate = new Date();
								searchForm[formKey] = formKey.includes('lf') ? currentDate : new Date(`${currentDate.getFullYear()}-${currentDate.getMonth()}-${currentDate.getDate()}`)
							} else {
								searchForm[formKey] = undefined;
							}
							item.arr = formKey;
						})
                        this.searchForm = new Object(searchForm);
						this.getDictionary()
						this.postHeight();
					} else {
                        this.postHeight();
                    }
				})
			},
			// 搜索
			onSearch() {
				this.$root.$bus.$emit("ReportQuery", {
					Conditions: this.getConditions(),
					IsTop100: !this.isRptYesSpotCheck2,
					ReportKey: this.rptKey
				});
			},
			// 组装搜索项目Conditions
			getConditions() {
				var Conditions = [];
				for(var key in this.searchForm) {
					const keyArr = key.split('|');
					if(!Conditions.find(e => e.ParaKey == keyArr[0])) {
						Conditions.push({
							ParaKey: keyArr[0],
							ParaVal: ' 1=1 '
						})
					}
					Conditions.map(ele => {
						if(ele.ParaKey == keyArr[0] && this.searchForm[key]) {
							ele.ParaVal += this.keyPlugin(key)
						}
					})
                }
                if(Object.is(this.rptKey, 'Dscl_ConsumeRecord')) {
                    Conditions.push({
                        ParaKey: "userid",
						ParaVal: this.iStorage.get("userId")
                    })
                }
				return Conditions;
			},
			keyPlugin(key) {
				var value;
                const keyArr = key.split('|');
                if(keyArr[4] == 'no') {
                    return ''
                }
				switch(keyArr[2]) {
					// 模糊查询
					case 'lk':
						value = `${keyArr[1]} LIKE '%${this.searchForm[key]}%'`;
						break;
						// 大于等于
					case 'lr':
						switch(keyArr[3]) {
							case 'Date':
								value = `${keyArr[1]} >= '${this.$formatDate(this.searchForm[key]._d, 'yyyy-MM-dd')}'`;
								break;
							case 'DateTime':
								value = `${keyArr[1]} >= '${this.$formatDate(this.searchForm[key]._d, 'yyyy-MM-dd HH:mm:ss')}'`;
								break;
						}
						break;
						// 小于等于
					case 'lf':
						switch(keyArr[3]) {
							case 'Date':
								value = `${keyArr[1]} <= '${this.$formatDate(this.searchForm[key]._d, 'yyyy-MM-dd')}'`;
								break;
							case 'DateTime':
								value = `${keyArr[1]} <= '${this.$formatDate(this.searchForm[key]._d, 'yyyy-MM-dd HH:mm:ss')}'`;
								break;
						}
						break;
						// 等于
					case 'le':
						switch(keyArr[3]) {
							case 'Date':
								value = `${keyArr[1]} = '${this.$formatDate(this.searchForm[key]._d, 'yyyy-MM-dd')}'`;
								break;
							case 'DateTime':
								value = `${keyArr[1]} = '${this.$formatDate(this.searchForm[key]._d, 'yyyy-MM-dd HH:mm:ss')}'`;
								break;
							default:
								value = `${keyArr[1]} = '${this.searchForm[key]}'`;
						}
						break;
				}
				return ` AND ${value}`;
			},
			// 字典查询
			getDictionary() {
				this.searchList.forEach((item, index) => {
					if(item.Type == 'Select') {
						this.$set(item, "isLoading", true);
						if (item.KeyCode != 'TPM') {
              this.FndictionaryQuery({
                keyCode: item.KeyCode
              }, index)
            } else {
              this.getTpmSetting(item.Tpm, index)
            }
					}
				})
			},
			// 下拉框选择
			selectQuery(item, index, value) {
				let KeyCodeVal, KeyCodeIndex;
				this.searchList.map((ele, index) => {
					if(item.CtrlName == ele.ParentCtrlName) {
						KeyCodeIndex = index;
						KeyCodeVal = [ele];
					}
				});
				//判断是否存在联级
				if(!Object.prototype.hasOwnProperty.call(item, 'ParentCtrlName') && KeyCodeVal && KeyCodeVal.length > 0) {
					this.searchForm[KeyCodeVal[0].arr] = null;
					this.FndictionaryQuery({
						keyCode: KeyCodeVal[0].KeyCode,
						lnkVal: value
					}, KeyCodeIndex)
				}
			},
			// 字典查询API
			FndictionaryQuery(params = {}, i) {
				this.$axios.FndictionaryQuery(params).then((result) => {
					this.$set(this.searchList[i], "DataSource", result.content);
					this.$set(this.searchList[i], "isLoading", false);
				})
			},
      getTpmSetting (config = {}, i) {
        let params = {
          "db": config.DBName,
          "collection": config.collection,
          "filter":{
            "$and":[
              {"keycode": config.keycode}
            ]
          },
          "projection":{
            "_id":-1,
            "options":1
          },
          "sort":{
            "priority":-1
          }
        }
        this.$axios.getTpmSetting(params).then((result) => {
          this.$set(this.searchList[i], "DataSource", result.content.options);
          this.$set(this.searchList[i], "isLoading", false);
        })
      },
			// 重置
			onReset() {
				for(var key in this.searchForm) {
					if(typeof this.searchForm[key] == 'object') {
						if(key.split('|')[3] == 'Date' || key.split('|')[3] == 'DateTime') {
							this.searchForm[key] = ''; //如果是时间选择器，那么输出的是object类型，并非字符串
						} else {
							this.searchForm[key] = []; //
						}
					} else if(typeof this.searchForm[key] == 'string') {
						this.searchForm[key] = '';
					} else if(typeof this.searchForm[key] == 'number') {
						this.searchForm[key] = '';
					}
				}
				this.onSearch();
			}
		}
	}
</script>

<style scoped="scoped" lang="scss">
	.reportSearchBox {
		border: 1px solid #bfcbd9;
		padding: 16px;
		border-radius: 5px;
		.titleBox {
			padding-bottom: 10px;
			border-bottom: 1px dashed #bfcbd9;
			margin-bottom: 15px;
			.left {
				// font-weight: bold;
			}
			.right {
				text-align: right;
				.btn {
					width: 120px;
					margin-left: 16px;
				}
			}
		}
	}
</style>
